import { render, staticRenderFns } from "./matrix-card-group.vue?vue&type=template&id=68b18f97&scoped=true"
import script from "./matrix-card-group.vue?vue&type=script&lang=js"
export * from "./matrix-card-group.vue?vue&type=script&lang=js"
import style0 from "./matrix-card-group.vue?vue&type=style&index=0&id=68b18f97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b18f97",
  null
  
)

export default component.exports